/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MoneyCurrencyRubleIcon16Regular = forwardRef('MoneyCurrencyRubleIcon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.75 9.75h-3v1.5H10a.75.75 0 1 1 0 1.5H6.75V14a.75.75 0 0 1-1.5 0v-1.25h-1.5a.75.75 0 0 1 0-1.5h1.5v-1.5h-1.5a.75.75 0 0 1 0-1.5h1.5V3.5c0-.69.56-1.25 1.25-1.25h3.25a3.75 3.75 0 1 1 0 7.5Zm-3-1.5v-4.5h3a2.25 2.25 0 1 1 0 4.5h-3Z" })));
});
